import { useIntl } from 'react-intl';
import Button from 'src/componentes/button';

const OnboardingFooter = ({
  showBack = true,
  isLastStep = false,
  onBack,
  onPrimaryAction,
  primaryLabel,
}) => {
  const intl = useIntl();

  const label =
    primaryLabel ??
    (isLastStep
      ? intl.formatMessage({ id: 'concluir' })
      : intl.formatMessage({ id: 'label.continuar' }));

  return (
     <div className={showBack ? 'footerOnboard' : 'footerOnboardWelcome'}>
      {showBack && (
        <Button onClick={onBack} color="secondary" >
          {intl.formatMessage({ id: 'label.voltar' })}
        </Button>
      )}

      <Button onClick={onPrimaryAction} color="primary">
        {label}
      </Button>
    </div>
  );
};

export default OnboardingFooter;
